// client/src/coms/views/canvas_parts/CanvasSelectionSettingsPanel.js
import React from 'react';

const SELECTION_OPTIONS = [
  { id: 'marquee_rect', label: 'Rectangle', icon: '⬚' },
  { id: 'marquee_ellipse', label: 'Ellipse', icon: '⬭' },
  { id: 'marquee_polygon', label: 'Lasso', icon: '⬡' },
  { id: 'marquee_polygon_edit', label: 'Editable', icon: '◇' },
];

export default function CanvasSelectionSettingsPanel({ activeTool, setActiveTool }) {
  return (
    <section
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        padding: 10,
        borderRadius: 12,
        border: '1px solid rgba(255,255,255,0.08)',
        background: 'rgba(255,255,255,0.035)',
      }}
    >
      <div
        style={{
          fontSize: 11,
          fontWeight: 950,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: 'rgba(255,255,255,0.62)',
        }}
      >
        Selection type
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: 6,
        }}
      >
        {SELECTION_OPTIONS.map((option) => {
          const active = activeTool === option.id;
          return (
            <button
              key={option.id}
              type="button"
              onClick={() => {
                if (typeof setActiveTool === 'function') setActiveTool(option.id);
              }}
              title={`${option.label} selection`}
              aria-pressed={active}
              style={{
                minWidth: 0,
                height: 58,
                borderRadius: 10,
                border: active
                  ? '1px solid rgba(180,215,255,0.58)'
                  : '1px solid rgba(255,255,255,0.08)',
                background: active
                  ? 'rgba(88,128,168,0.82)'
                  : 'rgba(255,255,255,0.045)',
                color: 'rgba(245,247,250,0.96)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 4,
                padding: 4,
                cursor: 'pointer',
                boxShadow: active ? 'inset 0 0 0 1px rgba(255,255,255,0.13)' : 'none',
              }}
            >
              <span style={{ fontSize: 20, lineHeight: 1 }}>{option.icon}</span>
              <span
                style={{
                  width: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 10,
                  fontWeight: 850,
                }}
              >
                {option.label}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
